import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (status) =>
    present(repository.removeProjectStatus(status).then(() => status));
}

export type { Interactor };

export { createInteractor };
